import { LicenseFeature } from '../../types';

export const frontlineSpecificFeatures: LicenseFeature[] = [
  { name: 'Shifts', included: false },
  { name: 'Tasks', included: false },
  { name: 'Walkie Talkie', included: false },
  { name: 'Staff Scheduling', included: false },
  { name: 'Approvals', included: false },
  { name: 'Updates', included: false },
  { name: 'Virtual Appointments', included: false },
  { name: 'Power Apps for Frontline', included: false },
  { name: 'Power Automate for Frontline', included: false },
  { name: 'Microsoft Stream', included: false },
  { name: 'Microsoft Lists', included: false },
  { name: 'Microsoft Forms', included: false },
  { name: 'Microsoft Entra ID P1', included: false },
  { name: 'Microsoft Intune', included: false },
  { name: 'Microsoft Defender for Office 365 P1', included: false },
  { name: 'Copilot Chat enhancements', included: false },
  { name: 'Copilot Chat Analytics', included: false },
];
